<div *ngIf="!isMobile" class="fixed inset-0 pointer-events-none z-50">
  <!-- Overlay de prévisualisation snap -->
  <div *ngIf="snapPreview === 'left'" class="absolute left-0 top-0 h-full w-1/2 snap-preview pointer-events-none z-50">
  </div>
  <div *ngIf="snapPreview === 'right'"
    class="absolute right-0 top-0 h-full w-1/2 snap-preview pointer-events-none z-50"></div>
  <div *ngIf="snapPreview === 'top'" class="absolute left-0 top-0 w-full h-full snap-preview pointer-events-none z-50">
  </div>

  <!-- Fenêtres -->
  <ng-container *ngFor="let win of windows$ | async; trackBy: trackByWindow">
    <div class="absolute pointer-events-auto shadow-lg bg-[var(--main)] rounded-2xl overflow-hidden window-container"
      [ngClass]="{
        'hidden': win.minimized,
        'active': win.isActive,
        'modified': win.isModified,
        'anchored-left': win.anchored === 'left',
        'anchored-right': win.anchored === 'right',
        'maximized': win.maximized,
        'minimizing': win.animating && win.animationType === 'minimize',
        'restoring': win.animating && win.animationType === 'restore',
        'window-appear': win.animating && win.animationType === 'appear',
        'window-close': win.animating && win.animationType === 'close',
        'dragging': draggingWindowId === win.id
      }" [ngStyle]="getWindowStyle(win)" [style.z-index]="win.isActive ? 999 : 100" cdkDrag
      (cdkDragMoved)="onDragMoved($event)" (cdkDragEnded)="onDragEnded($event, win)"
      (cdkDragStarted)="onDragStarted(win)" [cdkDragDisabled]="win.maximized || win.anchored"
      (mousedown)="setActiveWindow(win)" role="dialog" aria-modal="true"
      [attr.aria-label]="win.title || (win.type + ' #' + win.id)" tabindex="0" (focus)="onFocus(win)"
      (keydown)="onKeyDown($event, win)">

      <div class="h-full flex flex-col bg-[var(--main)]">
        <!-- Barre de titre -->
        <div
          class="flex items-center justify-between p-2 bg-[var(--main-light)] select-none border-b border-[var(--border)]"
          cdkDragHandle [class.cursor-move]="!(win.maximized || win.anchored)"
          (mousedown)="bringToFront(win); setActiveWindow(win)" role="banner" tabindex="0"
          [attr.aria-label]="'Barre de titre de ' + (win.title || (win.type + ' #' + win.id))"
          (keydown)="onTitleBarKeyDown($event, win)" (touchstart)="onTouchStart($event, win)"
          (touchmove)="onTouchMove($event, win)" (touchend)="onTouchEnd($event, win)">

          <span class="text-sm font-semibold text-[var(--text)] window-title" [class.modified]="win.isModified">
            {{ win.title || (win.type + ' #' + win.id) }}
          </span>

          <div class="flex gap-1 items-center window-controls">
            <button *ngIf="win.anchored" mat-icon-button (click)="unanchor(win)" matTooltip="Désancrer"
              class="text-[var(--text-light)] hover:bg-[var(--primary-hover)] hover:text-[var(--primary-color)]">
              <mat-icon>open_in_full</mat-icon>
            </button>

            <button *ngIf="win.canMinimize" mat-icon-button (click)="minimize(win)" matTooltip="Réduire"
              class="text-[var(--text-light)] hover:bg-[var(--primary-hover)] hover:text-[var(--primary-color)]">
              <mat-icon>minimize</mat-icon>
            </button>

            <button *ngIf="win.canMaximize && !win.maximized" mat-icon-button (click)="maximize(win)"
              matTooltip="Agrandir"
              class="text-[var(--text-light)] hover:bg-[var(--primary-hover)] hover:text-[var(--primary-color)]">
              <mat-icon>crop_square</mat-icon>
            </button>

            <button *ngIf="win.canMaximize && win.maximized" mat-icon-button (click)="restore(win)"
              matTooltip="Rétrécir"
              class="text-[var(--text-light)] hover:bg-[var(--primary-hover)] hover:text-[var(--primary-color)]">
              <mat-icon>filter_none</mat-icon>
            </button>

            <button mat-icon-button (click)="close(win)" matTooltip="Fermer"
              class="text-[var(--text-light)] hover:bg-[var(--error)] hover:text-[var(--error-color)]">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>

        <!-- Contenu de la fenêtre -->
        <div class="flex-1 overflow-auto bg-[var(--main)]">
          <app-window-content-wrapper [window]="win">
            <ng-container *ngFor="let w of [win]; trackBy: trackByWindow">
              <ng-container *ngComponentOutlet="w.component; injector: null; inputs: { data: w.data }"></ng-container>
            </ng-container>
          </app-window-content-wrapper>
        </div>

        <!-- Handles de redimensionnement (seulement si pas maximisée ou ancrée) -->
        <ng-container *ngIf="!win.maximized && !win.anchored">
          <!-- Handle bas-droite -->
          <div class="resize-handle" (mousedown)="startResize($event, win, 'se')"></div>

          <!-- Handle haut -->
          <div class="resize-handle-n" (mousedown)="startResize($event, win, 'n')"></div>

          <!-- Handle bas -->
          <div class="resize-handle-s" (mousedown)="startResize($event, win, 's')"></div>

          <!-- Handle droite -->
          <div class="resize-handle-e" (mousedown)="startResize($event, win, 'e')"></div>

          <!-- Handle gauche -->
          <div class="resize-handle-w" (mousedown)="startResize($event, win, 'w')"></div>
        </ng-container>
      </div>
    </div>
  </ng-container>
</div>

<!-- Version mobile -->
<div *ngIf="isMobile">
  <ng-container *ngIf="(windows$ | async) as windows">
    <ng-container *ngIf="windows.length > 0">
      <div class="fixed inset-0 z-50 bg-[var(--main)] flex flex-col">
        <div class="h-full flex flex-col bg-[var(--main)]">
          <div
            class="flex items-center justify-between p-2 bg-[var(--main-light)] select-none border-b border-[var(--border)]"
            (touchstart)="onTouchStart($event, windows[windows.length-1])"
            (touchmove)="onTouchMove($event, windows[windows.length-1])"
            (touchend)="onTouchEnd($event, windows[windows.length-1])">
            <span class="text-sm font-semibold text-[var(--text)]">
              {{ windows[windows.length-1].title || (windows[windows.length-1].type + ' #' +
              windows[windows.length-1].id) }}
            </span>
                      <div class="flex gap-1 items-center window-controls">
            <button mat-icon-button (click)="close(windows[windows.length-1])" (touchstart)="onButtonTouchStart($event)" (touchend)="onButtonTouchEnd($event)" matTooltip="Fermer"
              class="text-[var(--text-light)] hover:bg-[var(--error)] hover:text-[var(--error-color)]">
              <mat-icon>close</mat-icon>
            </button>
          </div>
          </div>
          <div class="flex-1 overflow-auto bg-[var(--main)]">
            <ng-container *ngFor="let w of [windows[windows.length-1]]; trackBy: trackByWindow">
              <ng-container *ngComponentOutlet="w.component; injector: null; inputs: { data: w.data }"></ng-container>
            </ng-container>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>
